import { Component, Renderer2 } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService'
import { AuthGuard } from './auth.guard';
import { sessionStorage } from './localstorage.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
// import
// import { LocalStorage } from './localstorage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'abacusdesk';
  login_data:any={};
  kei_user:any;
  st_user: any = {};
  data: any = [];

  constructor(public serve:DatabaseService,public session:sessionStorage,public router:Router,public renderer:Renderer2,private bnIdle: BnNgIdleService){
    this.session.getSession()
    .subscribe(resp=>{
      this.login_data = resp.data;
    });
    // this.ModuleRights()
  }
  ngOnInit(): void {
    window.onload = (event) => {
      document.getElementById("splashScreen").classList.add("splashScreenFadeHide")
     }
     document.getElementById("splashScreen").addEventListener('transitionend', (e) => {
       document.getElementById("splashScreen").style.display = 'none'
     })


     this.bnIdle.startWatching(3600).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        this.session.LogOutSession();
        this.router.navigate(['']);
        this.kei_user = JSON.parse(localStorage.getItem('st_user')) || [];
        this.kei_user = {};
        this.kei_user.st_log = false;
        localStorage.removeItem('st_user');
}

});


  };

//   ModuleRights() {


//     this.serve.auth_rqust({'id':this.login_data.id}, "CronJob/cacheIssueApiForDesignationLogin").subscribe((data: any) => {
// console.log('username',this.data['username'])
// console.log('password',this.data['password'])


//         console.log('success');

//         for (let i = 0; i < data['assignModule'].length; i++) {
//           if ((data['assignModule'][i]['module_name'] == 'CRM Leads' && data['assignModule'][i]['view'] == 'true')) {
//             data['data']['view_enquiry'] = 1;
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_enquiry'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_enquiry'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_enquiry'] = 1;
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_enquiry'] = 1;
//             }
//           }
//           if ((data['assignModule'][i]['module_name'] == 'Site' && data['assignModule'][i]['view'] == 'true')) {
//             data['data']['view_site'] = 1;
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_site'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_site'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_site'] = 1;
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_site'] = 1;
//             }
//           }

//           if ((data['assignModule'][i]['module_name'] == 'stock' && data['assignModule'][i]['view'] == 'true')) {
//             data['data']['view_stock'] = 1;
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_stock'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_stock'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_stock'] = 1;
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_stock'] = 1;
//             }
//           }
//           let report = [
//             { 'type': 'PJP-Detail-Report' },
//             { 'type': 'PJP-Summary-Report' },
//             { 'type': 'Attendance-Report' },
//             { 'type': 'Expense-Report' },
//             { 'type': 'Activity-Report' },
//             { 'type': 'Visit-Detail-Report' },
//             { 'type': 'Visit-Summary-Report' },
//             { 'type': 'Deviation-Detail-Report' },
//             { 'type': 'Deviation-Summary-Report' },
//             { 'type': 'Folder-Report' },
//             { 'type': 'Travelling-Km-Report' },
//             { 'type': 'Productive-Hour-Report' },
//             { 'type': 'Daily-Activity-Report' },
//             { 'type': 'Universe-Data-Report' },
//             { 'type': 'Universe-Summary-Report' },
//             { 'type': 'Leave-Report' },
//             { 'type': 'Event-Participants-Report' },
//             { 'type': 'Leave-Summary-Report' },
//             { 'type': 'Count-of-Visit-Report' },
//             { 'type': 'Employeewise-Distributor-Report' },
//             { 'type': 'List-of-Not-Visited-Report' },
//             { 'type': 'Custom-Report' }
//           ];

//           report.forEach(item => {
//             let reportType = item.type.replace(/-/g, '_');
//             console.log( reportType ,"Report type")
//             if (data['assignModule'][i]['module_name'] === reportType && data['assignModule'][i]['view'] === 'true') {
//               console.log("inside If")

//               data['data']['view_' + reportType] = 1;
//               console.log( data['data']['view_' + reportType] ,"line 117")
//             }
//           });

//           if (data['assignModule'][i]['module_name'] == 'Dashboard' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_dashboard'] = 1
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Location Master' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_location_master'] = 1
//           }
//           else if (data['assignModule'][i]['module_name'] == 'CRM Leads' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_enquiry'] = 1
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Secondary Sale Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_secondary_sale_report'] = 1
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Event_Customised_Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_Event_Customised_Report'] = 1
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Event_Feedback_Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_Event_Feedback_Report'] = 1
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Purchase_Sale_Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_Purchase_Sale_Report'] = 1
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Stock_Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_Stock_Report'] = 1
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Influencer Network' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_influencer_network'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_influencer'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_influencer'] = 1;
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_influencer'] = 1;
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_influencer'] = 1;
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'CRM Leads' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_crm_lead'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_crm_lead'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_crm_lead'] = 1;
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_crm_lead'] = 1;
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_crm_lead'] = 1;
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Customer Network' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_customer_network'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_customer_network'] = 1;
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_customer_network'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_customer_network'] = 1;
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_customer_network'] = 1;
//             }

//           }

//           else if (data['assignModule'][i]['module_name'] == 'Channel Partner' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_customer_network'] = 1
//             data['data']['view_channel_partner'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_channel_partner'] = 1;
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_channel_partner'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_channel_partner'] = 1;
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_channel_partner'] = 1;
//             }

//           }

//           else if (data['assignModule'][i]['module_name'] == 'Dealer' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_customer_network'] = 1
//             data['data']['view_dealer'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_dealer'] = 1;
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_dealer'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_dealer'] = 1;
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_dealer'] = 1;
//             }
//           }

//           else if (data['assignModule'][i]['module_name'] == 'Direct Dealers' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_customer_network'] = 1
//             data['data']['view_direct_dealers'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_direct_dealers'] = 1;
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_direct_dealers'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_direct_dealers'] = 1;
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_direct_dealers'] = 1;
//             }
//           }

//           else if (data['assignModule'][i]['module_name'] == 'Primary Orders' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_orders'] = 1
//             data['data']['view_primary_orders'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_primary_order'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_primary_order'] = 1;
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_primary_order'] = 1;
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_primary_order'] = 1;
//             }
//           }

//           else if (data['assignModule'][i]['module_name'] == 'Secondary Orders' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_orders'] = 1
//             data['data']['view_secondary_orders'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_secondary_orders'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_secondary_orders'] = 1;
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_secondary_orders'] = 1;
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_secondary_orders'] = 1;
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Invoice' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_accounts'] = 1
//             data['data']['view_invoice'] = 1

//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_invoice'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_invoice'] = 1;
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Payment' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_accounts'] = 1
//             data['data']['view_payment'] = 1

//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_payment'] = 1;
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_payment'] = 1;
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Attendance' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_attendence'] = 1
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_attendence'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_attendence'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Check In' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_check_in'] = 1;
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_checkin'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Leave' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_leaves'] = 1
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_leaves'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_leaves'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Travel Plan' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_travel_plan'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_travel_list'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_travel_list'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_travel_list'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_travel_list'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_travel_list'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Follow Up' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_follow_up'] = 1
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_follow_up'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_follow_up'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Announcement' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_announcement'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_announcement'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Expense' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_expense'] = 1
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_expense'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_expense'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_expense'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Event Plan' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_event_plan'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_event_plan'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_event_plan'] = 1
//             }
//           }

//           else if (data['assignModule'][i]['module_name'] == 'Pop & Gift' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_pop_gift'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_pop_gift'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_pop_gift'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_pop_gift'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_pop_gift'] = 1
//             }

//           }
//           else if (data['assignModule'][i]['module_name'] == 'Survey' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_survey'] = 1

//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_survey'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_survey'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_survey'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Gift Gallery' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_gift'] = 1
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_gift_gallery'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_gift_gallery'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_gift_gallery'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Bonus Points' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_bonus_points'] = 1
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_bonus_points'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_bonus_points'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_bonus_points'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Coupon Codes') {

//             if (data['assignModule'][i]['view'] == 'true') {
//               data['data']['view_coupon_code'] = 1
//             }

//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_coupon_code'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_coupon_code'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_coupon_code'] = 1
//             }
//           }

//           else if (data['assignModule'][i]['module_name'] == 'Redeem Request' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_redeem_request'] = 1
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_redeem_request'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_redeem_request'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Employee Target' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_target'] = 1
//             data['data']['view_employee_target'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_employee_target'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_employee_target'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_employee_target'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_employee_target'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_employee_target'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Distributor Target' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_target'] = 1
//             data['data']['view_distributor_target'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_distributor_target'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_distributor_target'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_distributor_target'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_distributor_target'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_distributor_target'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Category') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_category'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_category_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_category_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_category_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_category_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_category_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Sub Category') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_sub_category'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_sub_category_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_sub_category_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_sub_category_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_sub_category_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_sub_category_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Products') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_products'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_products_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_products_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_products_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_products_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_products_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'PDF') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_pdf'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_pdf_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_pdf_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_pdf_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_pdf_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_pdf_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Leave Master') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_leave_master'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_leave_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_leave_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_leave_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_leave_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_leave_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Users') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_users'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_users_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_users_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_users_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_users_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_users_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Designation') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_designation'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_users_designation'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_users_designation'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_users_designation'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_users_designation'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_users_designation'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Customer Category') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_customer_category'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_customer_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_customer_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_customer_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_customer_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_customer_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Influencer Category') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_infulencer_category'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_infulencer_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_infulencer_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_infulencer_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_infulencer_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_infulencer_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Point Category') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_point_category'] = 1


//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_point_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_point_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_point_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_point_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_point_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Holiday') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_holiday'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_holiday_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_holiday_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_holiday_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_holiday_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_holiday_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Gallery') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_gallery'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_gallery_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_gallery_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_gallery_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_gallery_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_gallery_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Referral Points Master') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_referral_point_master'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_referral_point_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_referral_point_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_referral_point_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_referral_point_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_referral_point_master'] = 1
//             }
//           }
//           else if ((data['assignModule'][i]['module_name'] == 'Allowance Master') && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_master'] = 1
//             data['data']['view_allowance_master'] = 1

//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_allowance_master'] = 1
//             }
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_allowance_master'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_allowance_master'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_allowance_master'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['import_allowance_master'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Image Gallery' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_support'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_support'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_support'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Task' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_task'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_task'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['export_task'] = 1
//             }
//           }

//           else if (data['assignModule'][i]['module_name'] == 'Sales Return' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_sales_return'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_sales_return'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_sales_return'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_sales_return'] = 1
//             }

//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_sales_return'] = 1
//             }

//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_sales_return'] = 1
//             }
//           }

//           else if (data['assignModule'][i]['module_name'] == 'Manual Dispatch' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_manual_dispatch'] = 1

//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_manual_dispatch'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_manual_dispatch'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_manual_dispatch'] = 1
//             }

//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_manual_dispatch'] = 1
//             }

//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_manual_dispatch'] = 1
//             }

//           }
//           else if (data['assignModule'][i]['module_name'] == 'Distributor_Sale_Not_Upload' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_product_wise_secondary_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_product_wise_secondary_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_product_wise_secondary_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_product_wise_secondary_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_product_wise_secondary_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_product_wise_secondary_report'] = 1
//             }
//           }

//           else if (data['assignModule'][i]['module_name'] == 'User Work Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_user_work_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_view_user_work_report_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_view_user_work_report_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_view_user_work_report_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_view_user_work_report_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_view_user_work_report_report'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Primary Target Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_primary_target_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_primary_target_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_primary_target_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_primary_target_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_primary_target_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_primary_target_report'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Secondary Target Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_secondary_target_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_secondary_target_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_secondary_target_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_secondary_target_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_secondary_target_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_secondary_target_report'] = 1
//             }
//           }

//           else if (data['assignModule'][i]['module_name'] == 'Channel Partner Sale Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_channel_partner_sale_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_channel_partner_sale_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_channel_partner_sale_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_channel_partner_sale_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_channel_partner_sale_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_channel_partner_sale_report'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Travel Plan Mis Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_travel_plan_mis_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_travel_plan_mis_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_travel_plan_mis_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_travel_plan_mis_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_travel_plan_mis_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_travel_plan_mis_report'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Month Wise Secondary Sale Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_month_wise_secondary_sale_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_month_wise_secondary_sale_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_month_wise_secondary_sale_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_month_wise_secondary_sale_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_month_wise_secondary_sale_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_month_wise_secondary_sale_report'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Primary Vs Secondary Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_primarywisesecondary_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_primarywisesecondary_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_primarywisesecondary_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_primarywisesecondary_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_primarywisesecondary_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_primarywisesecondary_report'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'State Wise Primary Secondary Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_statewiseprimarysecondary_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_statewiseprimarysecondary_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_statewiseprimarysecondary_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_statewiseprimarysecondary_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_statewiseprimarysecondary_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_statewiseprimarysecondary_report'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Order Summary Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_order_summary_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_order_summary_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_order_summary_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_order_summary_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_order_summary_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_order_summary_report'] = 1
//             }
//           }


//           else if (data['assignModule'][i]['module_name'] == 'Product Wise Primary Sales Report' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_reports'] = 1
//             data['data']['view_product_wise_sales_report'] = 1
//             if (data['assignModule'][i]['edit'] == 'true') {
//               data['data']['edit_product_wise_sales_report'] = 1
//             }
//             if (data['assignModule'][i]['delete'] == 'true') {
//               data['data']['delete_product_wise_sales_report'] = 1
//             }
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_product_wise_sales_report'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_product_wise_sales_report'] = 1
//             }
//             if (data['assignModule'][i]['import'] == 'true') {
//               data['data']['upload_product_wise_sales_report'] = 1
//             }
//           }

//           else if (data['assignModule'][i]['module_name'] == 'Dispatch Packing' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_dispatch_packing'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_dispatch_packing'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_dispatch_packing'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Dispatch Billing' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_dispatch_billing'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_dispatch_billing'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_dispatch_billing'] = 1
//             }
//           }
//           else if (data['assignModule'][i]['module_name'] == 'Dispatch Guard' && data['assignModule'][i]['view'] == 'true') {
//             data['data']['view_dispatch_guard'] = 1
//             if (data['assignModule'][i]['add'] == 'true') {
//               data['data']['add_dispatch_guard'] = 1
//             }
//             if (data['assignModule'][i]['export'] == 'true') {
//               data['data']['download_dispatch_guard'] = 1
//             }
//           }
//         }










//         data['data']['view_enquiry'] = 1;
//         data['data']['edit_enquiry'] = 1;
//         data['data']['add_enquiry'] = 1;
//         data['data']['delete_enquiry'] = 1;
//         data['data']['export_enquiry'] = 1;
//         data['data']['import_enquiry'] = 1;

//         data['data']['view_site'] = 1;
//         data['data']['edit_site'] = 1;
//         data['data']['add_site'] = 1;
//         data['data']['delete_site'] = 1;
//         data['data']['export_site'] = 1;
//         data['data']['import_site'] = 1;

//         data['data']['view_stock'] = 1;
//         data['data']['view_location_master'] = 1;
//         data['data']['edit_stock'] = 1;
//         data['data']['add_stock'] = 1;
//         data['data']['delete_stock'] = 1;
//         data['data']['export_stock'] = 1;
//         data['data']['import_stock'] = 1;

//         data['data']['view_dashboard'] = 1
//         data['data']['view_secondary_sale_report'] = 1
//         data['data']['view_Purchase_Sale_Report'] = 1
//         data['data']['view_Event_Customised_Report'] = 1
//         data['data']['view_Event_Feedback_Report'] = 1
//         data['data']['view_Stock_Report'] = 1
//         let report = [
//           { 'type': 'PJP-Detail-Report' },
//           { 'type': 'PJP-Summary-Report' },
//           { 'type': 'Attendance-Report' },
//           { 'type': 'Expense-Report' },
//           { 'type': 'Activity-Report' },
//           { 'type': 'Visit-Detail-Report' },
//           { 'type': 'Visit-Summary-Report' },
//           { 'type': 'Deviation-Detail-Report' },
//           { 'type': 'Deviation-Summary-Report' },
//           { 'type': 'Folder-Report' },
//           { 'type': 'Travelling-Km-Report' },
//           { 'type': 'Productive-Hour-Report' },
//           { 'type': 'Daily-Activity-Report' },
//           { 'type': 'Universe-Data-Report' },
//           { 'type': 'Universe-Summary-Report' },
//           { 'type': 'Leave-Report' },
//           { 'type': 'Event-Participants-Report' },
//           { 'type': 'Leave-Summary-Report' },
//           { 'type': 'Count-of-Visit-Report' },
//           { 'type': 'List-of-Not-Visited-Report' },
//           { 'type': 'Employeewise-Distributor-Report' },
//           { 'type': 'Custom-Report' }
//       ];

//       report.forEach(item => {
//           let reportType = item.type.replace(/-/g, '_');

//               data['data']['view_' + reportType] = 1;

//       });


//         data['data']['view_influencer_network'] = 1
//         data['data']['add_influencer'] = 1;
//         data['data']['export_influencer'] = 1;
//         data['data']['edit_influencer'] = 1;

//         data['data']['view_customer_network'] = 1;


//         data['data']['add_customer_network'] = 1;
//         data['data']['edit_customer_network'] = 1;
//         data['data']['export_customer_network'] = 1;
//         data['data']['import_customer_network'] = 1;

//         data['data']['view_channel_partner'] = 1;

//         data['data']['add_channel_partner'] = 1;
//         data['data']['import_channel_partner'] = 1;
//         data['data']['export_channel_partner'] = 1;
//         data['data']['edit_channel_partner'] = 1;

//         data['data']['view_dealer'] = 1
//         data['data']['add_dealer'] = 1;
//         data['data']['import_dealer'] = 1;
//         data['data']['export_dealer'] = 1;
//         data['data']['edit_dealer'] = 1;

//         data['data']['view_direct_dealers'] = 1
//         data['data']['add_direct_dealers'] = 1;
//         data['data']['import_direct_dealers'] = 1;
//         data['data']['export_direct_dealers'] = 1;
//         data['data']['edit_direct_dealers'] = 1;

//         data['data']['view_orders'] = 1
//         data['data']['add_order'] = 1;
//         data['data']['export_order'] = 1;
//         data['data']['edit_order'] = 1;
//         data['data']['delete_order'] = 1;

//         data['data']['view_primary_orders'] = 1
//         data['data']['add_primary_order'] = 1;
//         data['data']['export_primary_order'] = 1;
//         data['data']['edit_primary_order'] = 1;
//         data['data']['delete_primary_order'] = 1;

//         data['data']['view_secondary_orders'] = 1;
//         data['data']['add_secondary_orders'] = 1;
//         data['data']['export_secondary_orders'] = 1;
//         data['data']['edit_secondary_orders'] = 1;
//         data['data']['delete_secondary_orders'] = 1;



//         data['data']['view_accounts'] = 1
//         data['data']['view_invoice'] = 1
//         data['data']['view_payment'] = 1
//         data['data']['import_accounts'] = 1
//         data['data']['export_accounts'] = 1

//         data['data']['view_attendence'] = 1
//         data['data']['export_attendence'] = 1
//         data['data']['edit_attendence'] = 1

//         data['data']['view_check_in'] = 1
//         data['data']['export_checkin'] = 1

//         data['data']['view_leaves'] = 1
//         data['data']['export_leaves'] = 1
//         data['data']['edit_leaves'] = 1

//         data['data']['view_travel_plan'] = 1
//         data['data']['delete_travel_list'] = 1
//         data['data']['export_travel_list'] = 1
//         data['data']['edit_travel_list'] = 1
//         data['data']['import_travel_list'] = 1

//         data['data']['add_travel_list'] = 1

//         data['data']['view_follow_up'] = 1
//         data['data']['export_follow_up'] = 1
//         data['data']['delete_follow_up'] = 1

//         data['data']['view_announcement'] = 1
//         data['data']['add_announcement'] = 1

//         data['data']['view_expense'] = 1
//         data['data']['export_expense'] = 1
//         data['data']['edit_expense'] = 1
//         data['data']['add_expense'] = 1

//         data['data']['view_event_plan'] = 1
//         data['data']['edit_event_plan'] = 1
//         data['data']['add_event_plan'] = 1




//         data['data']['view_pop_gift'] = 1
//         data['data']['edit_pop_gift'] = 1
//         data['data']['delete_pop_gift'] = 1
//         data['data']['export_pop_gift'] = 1
//         data['data']['add_pop_gift'] = 1

//         data['data']['view_survey'] = 1
//         data['data']['add_survey'] = 1
//         data['data']['edit_survey'] = 1
//         data['data']['export_survey'] = 1

//         data['data']['view_gift'] = 1
//         data['data']['edit_gift_gallery'] = 1
//         data['data']['export_gift_gallery'] = 1
//         data['data']['add_gift_gallery'] = 1


//         data['data']['view_bonus_points'] = 1
//         data['data']['add_bonus_points'] = 1
//         data['data']['edit_bonus_points'] = 1
//         data['data']['export_bonus_points'] = 1


//         data['data']['view_coupon_code'] = 1
//         data['data']['export_coupon_code'] = 1
//         data['data']['add_coupon_code'] = 1
//         data['data']['delete_coupon_code'] = 1

//         data['data']['view_redeem_request'] = 1
//         data['data']['export_redeem_request'] = 1
//         data['data']['edit_redeem_request'] = 1

//         data['data']['view_target'] = 1
//         data['data']['view_employee_target'] = 1
//         data['data']['add_employee_target'] = 1
//         data['data']['edit_employee_target'] = 1
//         data['data']['export_employee_target'] = 1
//         data['data']['delete_employee_target'] = 1
//         data['data']['import_employee_target'] = 1

//         data['data']['view_distributor_target'] = 1
//         data['data']['add_distributor_target'] = 1
//         data['data']['edit_distributor_target'] = 1
//         data['data']['export_distributor_target'] = 1
//         data['data']['delete_distributor_target'] = 1
//         data['data']['import_distributor_target'] = 1


//         data['data']['view_master'] = 1

//         data['data']['view_designation'] = 1
//         data['data']['add_users_designation'] = 1
//         data['data']['edit_users_designation'] = 1
//         data['data']['export_users_designation'] = 1
//         data['data']['delete_users_designation'] = 1
//         data['data']['import_users_designation'] = 1

//         data['data']['view_category'] = 1
//         data['data']['view_sub_category'] = 1
//         data['data']['view_customer_category'] = 1
//         data['data']['view_infulencer_category'] = 1
//         data['data']['view_point_category'] = 1
//         data['data']['view_holiday'] = 1
//         data['data']['view_leave_master'] = 1
//         data['data']['view_referral_point_master'] = 1

//         data['data']['view_users'] = 1
//         data['data']['add_users_master'] = 1
//         data['data']['edit_users_master'] = 1
//         data['data']['export_users_master'] = 1
//         data['data']['delete_users_master'] = 1
//         data['data']['import_users_master'] = 1


//         data['data']['view_sub_category'] = 1
//         data['data']['add_sub_category_master'] = 1
//         data['data']['edit_sub_category_master'] = 1
//         data['data']['export_sub_category_master'] = 1
//         data['data']['delete_sub_category_master'] = 1
//         data['data']['import_sub_category_master'] = 1


//         data['data']['edit_master'] = 1
//         data['data']['add_master'] = 1
//         data['data']['delete_master'] = 1
//         data['data']['export_master'] = 1
//         data['data']['import_master'] = 1

//         data['data']['view_gallery'] = 1
//         data['data']['add_gallery_master'] = 1
//         data['data']['edit_gallery_master'] = 1
//         data['data']['export_gallery_master'] = 1
//         data['data']['delete_gallery_master'] = 1
//         data['data']['import_gallery_master'] = 1

//         data['data']['view_products'] = 1
//         data['data']['add_products_master'] = 1
//         data['data']['edit_products_master'] = 1
//         data['data']['export_products_master'] = 1
//         data['data']['delete_products_master'] = 1
//         data['data']['import_products_master'] = 1


//         data['data']['import_customer_master'] = 1
//         data['data']['delete_customer_master'] = 1
//         data['data']['export_customer_master'] = 1
//         data['data']['add_customer_master'] = 1
//         data['data']['edit_customer_master'] = 1

//         data['data']['add_infulencer_master'] = 1
//         data['data']['edit_infulencer_master'] = 1
//         data['data']['export_infulencer_master'] = 1
//         data['data']['delete_infulencer_master'] = 1
//         data['data']['import_infulencer_master'] = 1

//         data['data']['add_holiday_master'] = 1
//         data['data']['edit_holiday_master'] = 1
//         data['data']['export_holiday_master'] = 1
//         data['data']['delete_holiday_master'] = 1
//         data['data']['import_holiday_master'] = 1

//         data['data']['view_category'] = 1
//         data['data']['add_category_master'] = 1
//         data['data']['edit_category_master'] = 1
//         data['data']['export_category_master'] = 1
//         data['data']['delete_category_master'] = 1
//         data['data']['import_category_master'] = 1


//         data['data']['add_point_master'] = 1
//         data['data']['edit_point_master'] = 1
//         data['data']['export_point_master'] = 1
//         data['data']['delete_point_master'] = 1
//         data['data']['import_point_master'] = 1

//         data['data']['view_allowance_master'] = 1
//         data['data']['add_allowance_master'] = 1
//         data['data']['edit_allowance_master'] = 1
//         data['data']['export_allowance_master'] = 1
//         data['data']['delete_allowance_master'] = 1
//         data['data']['import_allowance_master'] = 1

//         data['data']['view_leave_master'] = 1
//         data['data']['add_leave_master'] = 1
//         data['data']['edit_leave_master'] = 1
//         data['data']['export_leave_master'] = 1
//         data['data']['delete_leave_master'] = 1
//         data['data']['import_leave_master'] = 1

//         data['data']['view_pdf'] = 1
//         data['data']['add_pdf_master'] = 1
//         data['data']['edit_pdf_master'] = 1
//         data['data']['export_pdf_master'] = 1
//         data['data']['delete_pdf_master'] = 1
//         data['data']['import_pdf_master'] = 1


//         data['data']['view_support'] = 1
//         data['data']['export_support'] = 1
//         data['data']['edit_support'] = 1

//         data['data']['view_task'] = 1
//         data['data']['add_task'] = 1
//         data['data']['export_task'] = 1

//         data['data']['view_sales_return'] = 1
//         data['data']['add_sales_return'] = 1
//         data['data']['edit_sales_return'] = 1
//         data['data']['delete_sales_return'] = 1
//         data['data']['download_sales_return'] = 1
//         data['data']['upload_sales_return'] = 1

//         data['data']['view_manual_dispatch'] = 1
//         data['data']['edit_manual_dispatch'] = 1
//         data['data']['delete_manual_dispatch'] = 1
//         data['data']['add_manual_dispatch'] = 1
//         data['data']['download_manual_dispatch'] = 1
//         data['data']['upload_manual_dispatch'] = 1

//         data['data']['view_reports'] = 1
//         data['data']['view_product_wise_secondary_report'] = 1
//         data['data']['edit_product_wise_secondary_report'] = 1
//         data['data']['delete_product_wise_secondary_report'] = 1
//         data['data']['add_product_wise_secondary_report'] = 1
//         data['data']['download_product_wise_secondary_report'] = 1
//         data['data']['upload_product_wise_secondary_report'] = 1

//         data['data']['view_user_work_report'] = 1
//         data['data']['edit_view_user_work_report_report'] = 1
//         data['data']['delete_view_user_work_report_report'] = 1
//         data['data']['add_view_user_work_report_report'] = 1
//         data['data']['download_view_user_work_report_report'] = 1
//         data['data']['upload_view_user_work_report_report'] = 1

//         data['data']['view_primary_target_report'] = 1
//         data['data']['edit_primary_target_report'] = 1
//         data['data']['delete_primary_target_report'] = 1
//         data['data']['add_primary_target_report'] = 1
//         data['data']['download_primary_target_report'] = 1
//         data['data']['upload_primary_target_report'] = 1

//         data['data']['view_secondary_target_report'] = 1
//         data['data']['edit_secondary_target_report'] = 1
//         data['data']['delete_secondary_target_report'] = 1
//         data['data']['add_secondary_target_report'] = 1
//         data['data']['download_secondary_target_report'] = 1
//         data['data']['upload_secondary_target_report'] = 1

//         data['data']['view_channel_partner_sale_report'] = 1
//         data['data']['edit_channel_partner_sale_report'] = 1
//         data['data']['delete_channel_partner_sale_report'] = 1
//         data['data']['add_channel_partner_sale_report'] = 1
//         data['data']['download_channel_partner_sale_report'] = 1
//         data['data']['upload_channel_partner_sale_report'] = 1

//         data['data']['view_order_summary_report'] = 1
//         data['data']['edit_order_summary_report'] = 1
//         data['data']['delete_order_summary_report'] = 1
//         data['data']['add_order_summary_report'] = 1
//         data['data']['download_order_summary_report'] = 1
//         data['data']['upload_order_summary_report'] = 1

//         data['data']['view_travel_plan_mis_report'] = 1
//         data['data']['edit_travel_plan_mis_report'] = 1
//         data['data']['delete_travel_plan_mis_report'] = 1
//         data['data']['add_travel_plan_mis_report'] = 1
//         data['data']['download_travel_plan_mis_report'] = 1
//         data['data']['upload_travel_plan_mis_report'] = 1

//         data['data']['view_month_wise_secondary_sale_report'] = 1
//         data['data']['edit_month_wise_secondary_sale_report'] = 1
//         data['data']['delete_month_wise_secondary_sale_report'] = 1
//         data['data']['add_month_wise_secondary_sale_report'] = 1
//         data['data']['download_month_wise_secondary_sale_report'] = 1
//         data['data']['upload_month_wise_secondary_sale_report'] = 1

//         data['data']['view_primarywisesecondary_report'] = 1
//         data['data']['edit_primarywisesecondary_report'] = 1
//         data['data']['delete_primarywisesecondary_report'] = 1
//         data['data']['add_primarywisesecondary_report'] = 1
//         data['data']['download_primarywisesecondary_report'] = 1
//         data['data']['upload_primarywisesecondary_report'] = 1

//         data['data']['view_statewiseprimarysecondary_report'] = 1
//         data['data']['edit_statewiseprimarysecondary_report'] = 1
//         data['data']['delete_statewiseprimarysecondary_report'] = 1
//         data['data']['add_statewiseprimarysecondary_report'] = 1
//         data['data']['download_statewiseprimarysecondary_report'] = 1
//         data['data']['upload_statewiseprimarysecondary_report'] = 1

//         data['data']['view_product_wise_sales_report'] = 1
//         data['data']['edit_product_wise_sales_report'] = 1
//         data['data']['delete_product_wise_sales_report'] = 1
//         data['data']['add_product_wise_sales_report'] = 1
//         data['data']['download_product_wise_sales_report'] = 1
//         data['data']['upload_product_wise_sales_report'] = 1


//         data['data']['view_dispatch_packing'] = 1
//         data['data']['add_dispatch_packing'] = 1
//         data['data']['download_dispatch_packing'] = 1

//         data['data']['view_dispatch_billing'] = 1
//         data['data']['add_dispatch_billing'] = 1
//         data['data']['download_dispatch_billing'] = 1


//         data['data']['view_dispatch_guard'] = 1
//         data['data']['add_dispatch_guard'] = 1
//         data['data']['download_dispatch_guard'] = 1








//           this.st_user = data;
//           console.log(this.st_user.data);
//           this.st_user.data.access_level = "1";
//           this.st_user.st_log = true;
//           localStorage.setItem('st_user', JSON.stringify(this.st_user));
//           console.log('in else');






//     }, error => {
//     });
//   }
}
